import React, { useEffect } from 'react';
import { Grid, Container } from '@material-ui/core';
import i18n from 'i18n-js';
import Title from 'components/Title';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import { useDispatch, useSelector } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';

import { VehicleTypeDetailsWidget, VehicleTypeLogs } from 'components/VehiclesTypes';
import Can from 'components/Can';
import { VehicleTypeImages } from 'components/VehiclesTypes';
import useStyles from './VehicleType.styled';
import { useParams } from 'react-router-dom';

const VehicleTypeDetails = () => {
  const { id } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { vehicleType } = useSelector((state) => state.vehicles);

  useEffect(() => {
    if (id) {
      dispatch(vehicleActions.fetchVehicleTypeById(id));
    }
    dispatch(vehicleActions.resetVehicleTypeOnboarding());
  }, []) // eslint-disable-line

  return (
    <Layout title={i18n.t('vehicle.details_title')}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2} direction="row" justifyContent="space-between">
              <Grid item>
                <Title
                  title={`${i18n.t('vehicle_types.vehicle_type')} - ${vehicleType?.year || ''} ${
                    vehicleType?.make || ''
                  } ${vehicleType?.model || ''} ${vehicleType?.powertrain || ''}`}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <VehicleTypeDetailsWidget vehicleType={vehicleType} />
                  </Grid>
                  <Grid item xs={12}>
                    <VehicleTypeImages id={vehicleType?.id} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Comments type="vehicle_type" id={parseInt(id)} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Can I="read" on="event_log">
                      <Grid item xs={12}>
                        <VehicleTypeLogs id={id} />
                      </Grid>
                    </Can>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default VehicleTypeDetails;
